import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 20,
  pageOptions: [20, 50, 100],
  totalRows: 1,
  sortOptions: [],
  fields: [
    { key: 'consultation_number', label: 'Nomor Konsultasi'},
    { key: 'invoice_number', label: 'invoice'},
    { key: 'user_name', label: 'Nama Pengguna', sortable: true },
    { key: 'detail', label: 'Layanan'},
    { key: 'practition_name', label: 'Nama Praktisi Hukum', sortable: true },
    { key: 'payment', label: 'Cara Bayar'},
    { key: 'total', label: 'Total'},
    { key: 'updated_at', label: 'Last Update', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action'},
  ],
  items: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'report/transactions/status/ED'}
    useIPA.get(param).then(response => {
      const transaction = {
        rows : response.data.data
      }
      commit('setData', {...transaction})
    })
  },

  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'report/transaction/' + id}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const rawData = {
        status: formData.select_1,
			}
      const param = { rawData: rawData, url: 'dashboard/report/transaction/status', id: formData.id }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'report' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/profession', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, transaction) {
    state.items = transaction.rows
    state.totalRows = transaction.rows.length
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
